import { render } from "./BaseInfo.vue?vue&type=template&id=0a9cdc7a&scoped=true&ts=true"
import script from "./BaseInfo.vue?vue&type=script&lang=ts"
export * from "./BaseInfo.vue?vue&type=script&lang=ts"

import "./BaseInfo.vue?vue&type=style&index=0&id=0a9cdc7a&lang=less&scoped=true"

import exportComponent from "/workspace/workdir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9cdc7a"]])

export default __exports__